import { useCallback } from 'react';
import { useSMLRouter } from '../../../routing/sml/hooks';
import { SMLRoutes } from '../../../routing/sml/SMLRoutes';
import { useToastAction } from '../../../redux/slices/toasts/hooks';

/** The id of the action in the toast after "Exit tour" (design: onboarding b6). */
export const TOUR_ADD_SONG_TOAST_ACTION = 'tour.addSong';

/**
 * Registers "Set up my own song" of the exit toast. The shell calls it, because the guide bar is
 * gone when the toast shows. "Add my song" selects the own artist itself.
 */
export function useTourToastActions(): void {
  const { push } = useSMLRouter();
  const openAddSong = useCallback(() => push(SMLRoutes.addSong), [push]);
  useToastAction(TOUR_ADD_SONG_TOAST_ACTION, openAddSong);
}
